import "./Affiliate.css";
import ocean from "../../../../../assets/ocean.png";
import cancel from "../../../../../assets/cancel.png";
const AffiliateModal = ({ setAffiliateModal }) => {
 return (
  <div className="affiliate-modal">
   <div className="overlay"></div>
   <div className="modal-box">
    <div className="header">
     <p className="title">Affiliate Link</p>
     <p
      className="close-modal"
      onClick={() => {
       setAffiliateModal(false);
      }}
     >
      <img src={cancel} alt="cancel" />
     </p>
    </div>
    <div className="image-container">
     <div>
      <img src={ocean} alt="share" />
     </div>
     <div className="title">Mind Games of a Broken Heart</div>
    </div>

    <div className="link-container">
     <div>
      <p>Copy link</p>
     </div>
     <div className="modal-custom-input">
      <input
       type="text"
       defaultValue="https://app.shap.com/product/706897056506...."
      />
      <div className="copy-shapBtn">Copy</div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default AffiliateModal;
